import useIsFeatureEnabled from './useIsFeatureEnabled';
import useIsLabFeatureEnabled from './useIsLabFeatureEnabled';

const useIsMyLearningEnabled = () => {
  const isFeatureEnabled = useIsFeatureEnabled('PA-4045-My-Learning');
  const isLabEnabled = useIsLabFeatureEnabled('up_next');

  return isFeatureEnabled && isLabEnabled;
};

export default useIsMyLearningEnabled;
